module.exports = __webpack_public_path__ + "static/media/download.b0a7386f.svg";